export default __webpack_public_path__ + "static/media/img-banner-2@2x.7bc297b3.png";